import { render, staticRenderFns } from "./EchartsPie.html?vue&type=template&id=4c56216a&scoped=true&external"
import script from "./EchartsPie.js?vue&type=script&lang=js&external"
export * from "./EchartsPie.js?vue&type=script&lang=js&external"
import style0 from "./EchartsPie.vue?vue&type=style&index=0&id=4c56216a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56216a",
  null
  
)

export default component.exports